module.exports = __webpack_public_path__ + "img/UTFREM-1.25e5719f.jpg";